import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizeUrlPathAsyncPipe } from './localize-url-path-async.pipe';
import { LocalizeUrlPathPipe } from './localize-url-path.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [LocalizeUrlPathPipe, LocalizeUrlPathAsyncPipe],
  exports: [LocalizeUrlPathPipe, LocalizeUrlPathAsyncPipe],
})
export class LocalizeUrlPathModule {}
